import { MessageCircle } from "lucide-react";
import LangLink from "../shared/LangLink";
import { SITE } from "../../data/site";
import { useI18n } from "../../i18n";

// Sticky lower bar on mobile only: WhatsApp + Request a Case Review.
export default function MobileStickyBar() {
  const { t } = useI18n();
  return (
    <div
      className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-background/90 backdrop-blur-xl border-t border-border px-4 py-3 flex items-center gap-3"
      data-testid="mobile-sticky-bar"
    >
      <a
        href={SITE.whatsappHref}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center gap-2 rounded-full border border-primary/25 text-primary px-4 py-3 text-sm font-medium font-sans flex-1"
        data-testid="sticky-whatsapp"
      >
        <MessageCircle className="w-4 h-4" /> {t("cta.whatsapp")}
      </a>
      <LangLink
        to="/#case-review"
        className="inline-flex items-center justify-center rounded-full bg-primary text-primary-foreground px-4 py-3 text-sm font-medium font-sans flex-[1.4] text-center"
        data-testid="sticky-case-review"
      >
        {t("cta.caseReview")}
      </LangLink>
    </div>
  );
}

// Persistent, non-intrusive WhatsApp button (desktop, bottom-right).
export function WhatsAppFloat() {
  return (
    <a
      href={SITE.whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      className="hidden md:flex fixed bottom-8 right-8 z-40 items-center justify-center w-14 h-14 rounded-full bg-primary text-primary-foreground shadow-lg hover:bg-accent hover:text-accent-foreground transition-all duration-300 hover:-translate-y-1"
      aria-label="Contact us on WhatsApp"
      data-testid="whatsapp-float"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
}
